<template>
  <el-date-picker
    v-model="dates"
    type="daterange"
    align="right"
    format="MMM d"
    range-separator="-"
    start-placeholder="Start date"
    end-placeholder="End date"
    :picker-options="pickerOptions"
    @change="setDate"
    popper-class="date-picker"
  />
</template>

<script>
  export default {
    name: 'the-date-picker',
    data () {
      return {
        dates: null
      }
    },
    props: {
      initialDates: {
        type: Array,
        default: () => []
      },
      pickerOptions: {
        type: Object,
        default: () => {}
      }
    },
    mounted () {
      this.dates = [this.initialDates[0], this.initialDates[1]]
    },
    methods: {
      setDate (dates) {
        this.$emit('setDate', dates)
      }
    }
  }
</script>
<style>
  .date-picker {
    font-family: Roboto,sans-serif;
  }
</style>
